// D-1026: SGP 要確認(未確認のもの)の一覧と件数。
//   バッジ(ランチャーのタナサポ)・タナサポ入口の案内・入荷チェックの要確認レーンが同じこれを使う(数を揃える)。
//   作りは D-889 useFeedbackReplyBadge と同じ: ポーリングしない。①マウント時 ②前面に戻ったとき ③refresh() で取り直す。
//   取得に失敗したら 0 件(バッジを出さない。誤った数を出さない)。
import { useCallback, useEffect, useRef, useState } from 'react'
import { fetchPendingSgpReviews } from '../services/sgpReview'

export function useSgpReviews({ enabled = true, locationId = null } = {}) {
  const [rows, setRows] = useState([])
  const inflight = useRef(false)
  const alive = useRef(true)

  const refresh = useCallback(async () => {
    if (!enabled || inflight.current) return
    inflight.current = true
    try {
      const res = await fetchPendingSgpReviews({ locationId })
      if (alive.current) setRows(res?.ok ? res.rows : [])
    } catch {
      if (alive.current) setRows([])
    } finally {
      inflight.current = false
    }
  }, [enabled, locationId])

  useEffect(() => {
    alive.current = true
    if (!enabled) { setRows([]); return () => { alive.current = false } }
    refresh()
    const onFocus = () => { refresh() }
    const onVisible = () => {
      try { if (document.visibilityState === 'visible') refresh() } catch { /* ignore */ }
    }
    window.addEventListener('focus', onFocus)
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      alive.current = false
      window.removeEventListener('focus', onFocus)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [enabled, refresh])

  return { rows, count: rows.length, refresh }
}
